import { render, staticRenderFns } from "./ProductListWrapper.vue?vue&type=template&id=0aebe7fa&scoped=true&"
import script from "./ProductListWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductListWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProductListWrapper.vue?vue&type=style&index=0&id=0aebe7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aebe7fa",
  null
  
)

export default component.exports